import OdooSOPreview from "components/shared/OdooSOPreview";

const OdooOrderView = ({ order }) => {
  return (
    <div className="card">
      <OdooSOPreview {...order} />
    </div>
  );
};

export default OdooOrderView;
